(function () {
  function getBalkonSectionId() {
    const section = document.querySelector('#balkonLandingSolutions')?.closest('.shopify-section');
    return section ? section.id.replace('shopify-section-', '') : '';
  }

  function relocateBalkonModals() {
    const sectionId = getBalkonSectionId();

    document.querySelectorAll('modal-dialog.balkonPointModal quick-add-modal').forEach((modal) => {
      if (sectionId) modal.dataset.section = sectionId;
      modal.moved = true;

      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });

    document.querySelectorAll('#balkonLandingSolutions quick-add-modal').forEach((modal) => {
      if (modal.moved) return;
      if (sectionId) modal.dataset.section = sectionId;
      modal.moved = true;

      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  function bindSubproductRowClicks() {
    document.querySelectorAll('.balkonSubproductRow').forEach((row) => {
      if (row.dataset.balkonRowBound) return;
      row.dataset.balkonRowBound = 'true';

      row.addEventListener('click', (event) => {
        if (event.target.closest('button, a, input, select, label, modal-opener')) return;
        const quickAddBtn = row.querySelector('[id^="balkonSubQuickAddBtn-"]');
        if (quickAddBtn) quickAddBtn.click();
      });
    });
  }

  relocateBalkonModals();
  bindSubproductRowClicks();
  document.addEventListener('shopify:section:load', () => {
    relocateBalkonModals();
    bindSubproductRowClicks();
  });
})();